import { post } from "@shared/utils/server";

import { FetchGamesResponse } from "./types";

export const fetchGamesIds = async (): Promise<
  FetchGamesResponse | undefined
> => {
  const response = await post({
    method: "Game.getRecommendations",
    args: {},
  });

  if (!Array.isArray(response)) {
    console.error("recommended games must be array");
    return;
  }

  if (isGamesResponse(response[0])) {
    return response[0];
  }
};

function isGamesResponse(
  response: FetchGamesResponse | unknown[] | Error
): response is FetchGamesResponse {
  return (response as FetchGamesResponse).games !== undefined;
}
